// src/admin/pages/CategoriesPage.jsx

import { useState } from "react";

import PageHeader from "../components/PageHeader";
import SearchInput from "../components/SearchInput";
import AdminModal from "../components/AdminModal";
import CategoryForm from "../components/CategoryForm";
import CategoriesTable from "../components/CategoriesTable";

import useCategories from "../hooks/useCategories";

export default function CategoriesPage() {

    const [open, setOpen] = useState(false);
    const [selectedCategory, setSelectedCategory] = useState(null);
    const [search, setSearch] = useState("");

    const handleAdd = () => {
        setSelectedCategory(null);
        setOpen(true);
    };

    const handleEdit = (category) => {
        setSelectedCategory(category);
        setOpen(true);
    };

    const handleSubmit = async (data) => {

        if (selectedCategory) {
          console.log(data);
            await updateCategory(selectedCategory.id, data);
        } else {
            await createCategory(data);
        }

        setOpen(false);
        setSelectedCategory(null);
    };

    

    const {
        categories,
        loading,
        saving,
        deletingId,
        createCategory,
        updateCategory,
        deleteCategory,
    } = useCategories(search);

    return (
        <div className="space-y-8">

            <PageHeader
                title="Categories"
                subtitle="Content Management"
                actionButton={
                    <button
                        onClick={handleAdd}
                        className="
                            px-6
                            py-3
                            rounded-xl
                            bg-blue-800
                            text-white
                            font-semibold
                            hover:bg-blue-600
                            transition
                        "
                    >
                        Add Category
                    </button>
                }
            />

              <SearchInput
                value={search}
                onChange={(setSearch)}
                placeholder="Search posts..."
              />

            {loading ? (

                <div className="text-center py-16">
                    Loading categories...
                </div>

            ) : (

                <CategoriesTable
                    categories={categories}
                    deletingId={deletingId}
                    onDelete={deleteCategory}
                    onEdit={handleEdit}
                />

            )}

            <AdminModal
                isOpen={open}
                title={
                    selectedCategory
                        ? "Edit Category"
                        : "Add Category"
                }
                onClose={() => {
                    setOpen(false);
                    setSelectedCategory(null);
                }}
            >
              <CategoryForm
                  initialValues={selectedCategory}
                  saving={saving}
                  onSubmit={handleSubmit}
              />  
            </AdminModal>

        </div>
    );
}